// import collection online locales
import local_en from "@/locales/en";
import local_es from "@/locales/es";
import merge from "lodash.merge";

import { locales } from "@thegetty-private/getty-ui";
import { locales as imageViewerLocales } from "@thegetty-private/image-viewer";

// combine locale objects for each language
const en = merge(locales.messages.en, imageViewerLocales.messages.en, local_en);
const es = merge(local_es, {});

// create and export a single locales object
export const messages = { en, es };
export const dateTimeFormats = locales.dateTimeFormats;
